import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'

export default function () {
  const history = useHistory()
  const { locale } = useIntl()
  useEffect(() => history.push(`/${locale}`))  
  return null
}